import styled from "styled-components";
import { color } from "../../../../shared/styles";

export const AssigneeBox = styled.div`
    padding: 16px;
    border-radius: 16px;
    display: flex;
    width: 100%;
    background-color: ${color.status.INFO_LIGHT};
    box-sizing: border-box;

    .left {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .title {
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 22px;
        }

        .content {
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            display: flex;
            gap: 8px;
            align-items: center;
        }
    }

    .right {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }
`;

interface AssigneeSearchProps {
    isFocus: boolean;
}

export const AssigneeSearch = styled.div<AssigneeSearchProps>`
    display: flex;
    height: 40px;
    justitfy-content: space-between;

    padding: 8px 16px 8px 16px;
    box-sizing: border-box;
    border-radius: 24px;
    width: 216px;
    background: white;
    border: solid 1px ${color.secondary.BORDER};
`;

export const StyledInput = styled.input`
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    border: none;

    &::placeholder {
        color: ${color.emphasis.NEUTRAL_N30};
    }

    &:focus {
        border: none;
        box-shadow: none;
        outline: none;
    }
`;
